/* =====================================================
   Game Controls Component – Version 2.1 (Modified: July 31, 2025)
   Number/operator selection and control buttons
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

import NumberSelector from './NumberSelector'
import OperatorSelector from './OperatorSelector'
import ControlButtons from './ControlButtons'
import styles from './GameControls.module.css'

/**
 * Main game controls section containing number/operator selection and buttons
 */
function GameControls() {
  return (
    <footer className={styles.bottomPanel}>
      <div className={styles.gameControls}>
        {/* Number and operator selection area */}
        <div className={styles.controlsRow}>
          <NumberSelector />
          <OperatorSelector />
        </div>

        {/* Game action buttons */}
        <ControlButtons />
      </div>
    </footer>
  )
}

export default GameControls